import { render } from "./entry.vue?vue&type=template&id=5b7f6fcd"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"

import "./entry.vue?vue&type=style&index=0&id=5b7f6fcd&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__